import SimplePage from "@/components/layout/SimplePage";

const ROLES = [
  "President",
  "Vice President",
  "Treasurer",
  "Secretary",
  "Membership Chair",
  "Religious-School Liaison",
  "Social-Action Chair",
  "Fundraising / Gala Chair",
  "Worship Committee Chair",
  "Trustee at Large",
  "Trustee at Large",
  "Past President",
];

export default function Board() {
  return (
    <SimplePage
      title="Meet Our Board"
      eyebrow="Leadership"
      subtitle="The volunteer trustees who guide TIOB's vision, governance, and stewardship."
      path="/about/board"
      ctaLabel="Contact the Board"
      aside={
        <div className="card-soft p-6 bg-[var(--cream)] border-[var(--line-warm)]">
          <p className="eyebrow mb-2">★ Board Meetings</p>
          <p className="text-[var(--ink-soft)] text-sm">
            The Board of Trustees meets monthly. Members in good standing are
            warmly welcome to attend and observe. Please contact the office for
            the next meeting date and time.
          </p>
        </div>
      }
    >
      <p>
        Temple Israel of Brevard is governed by a volunteer Board of Trustees
        elected from our membership. Our trustees give their time, their
        expertise, and their hearts to ensure TIOB remains a thriving, welcoming,
        and financially-sound Jewish home for the next generation.
      </p>
      <p>
        Trustees serve staggered terms and meet monthly. The Board oversees
        budgeting, building stewardship, worship and education programming,
        membership growth, and our many community partnerships.
      </p>

      <h2>Board Positions</h2>
      <ul>
        {ROLES.map((r) => (
          <li key={r}>{r}</li>
        ))}
      </ul>
      <p className="text-sm text-[var(--muted)] italic">
        For a current roster of trustees and their contact information, please
        call the office at (321) 631-9494.
      </p>

      <h2>Interested in Serving?</h2>
      <p>
        We are always glad to talk with members who feel called to serve on the
        Board or on a committee. Tell us where your gifts lie - finance,
        education, social action, building, programming, communications - and
        we'll find you a meaningful role.
      </p>
    </SimplePage>
  );
}
